import { render, staticRenderFns } from "./TIPO_MENU.vue?vue&type=template&id=660ff359"
import script from "./TIPO_MENU.vue?vue&type=script&lang=js"
export * from "./TIPO_MENU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports